import {
  apiRequest,
  penilaianTunjanganKhususCreate,
  penilaianTunjanganKhususUpdate,
} from "../../../../../services/adapters/kepegawaian/penilaianTunjanganKhususService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      penilaianTunjanganKhususUpdate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
